module.exports = __webpack_public_path__ + "static/media/donor.c1278632.png";